import { useEffect, useCallback } from 'react';
import usePromiseModalState from '@sdk/components/ui/modal/usePromiseModalState';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import PauseSubscriptionModal from '@web/account/billing/PauseSubscriptionModal/PauseSubscriptionModal';
import { BillingInfoProvider } from '@web/account/billing/BillingInfoContext';

const PauseSubscriptionModalAngular = ({ shown, onClose, billingInfo, fromDeleteOrg = false }) => {
  const pauseSubscriptionModalState = usePromiseModalState();

  const open = useCallback(async () => {
    const paused = await pauseSubscriptionModalState.getResult();
    onClose(paused);
  }, [onClose, pauseSubscriptionModalState]);

  useEffect(() => {
    if (shown) {
      open();
    }
  }, [shown]); // eslint-disable-line

  if (!billingInfo) {
    return null;
  }

  return (
    <BillingInfoProvider billingInfo={billingInfo}>
      <PauseSubscriptionModal {...pauseSubscriptionModalState} fromDeleteOrg={fromDeleteOrg} />
      <ToastComponent />
    </BillingInfoProvider>
  );
};

export default {
  ReactComponent: PauseSubscriptionModalAngular,
  bindings: {
    shown: '<',
    onClose: '<',
    billingInfo: '<',
    fromDeleteOrg: '<?',
  },
};
